export default {
  "widget.defaultTitle": "在线咨询",
  "widget.defaultSubtitle": "我们很乐意为您提供帮助",
  "widget.defaultGreeting": "您好！请问有什么可以帮您的吗？",
  "chat.close": "关闭聊天",
  "chat.open": "打开聊天",
  "chat.expand": "展开聊天",
  "chat.collapse": "收起聊天",
  "chat.conversationEnded": "此对话已结束",
  "chat.startNew": "开始新对话",
  "chat.poweredBy": "技术支持",
  "chat.conversationClosed": "对话已关闭",
  "chat.aiLabel": "AI 助手",
  "input.placeholder": "输入消息...",
  "input.send": "发送消息",
  "error.sendFailed": "消息发送失败，请稍后再试。",
  "error.messageTooLong": "消息过长，请缩短后重试。",
  "chat.teamMember": "一位团队成员",
  "chat.agentJoined": "{name} 加入了对话",
  "chat.agentLeft": "{name} 离开了对话",
  "chat.agentReturnedToAi": "{name} 离开了对话。您现在再次与 AI 助手对话。",
  "availability.open": "营业中",
  "availability.backAt": "{when}恢复",
  "availability.closed": "当前非营业时间",
  "waiting.title": "正在等待人工客服",
  "waiting.typical": "通常在{time}内回复",
  "waiting.alerted": "我们已通知团队。",
  "waiting.closed": "团队将于{when}回来。在此之前，AI 助手可以继续为您提供帮助。",
  "waiting.minutes": "约{n}分钟",
  "waiting.hours": "约{n}小时",
  "contact.prompt": "留下您的邮箱，如果您已离开，我们会将团队的回复发送到您的邮箱。",
  "contact.label": "邮箱",
  "contact.placeholder": "you@example.com",
  "contact.submit": "通知我",
  "contact.consent": "我们只会使用您的邮箱回复此对话。",
  "contact.saved": "谢谢！如果团队回复时您已离开，我们会给您发送邮件。",
  "contact.failed": "无法保存您的邮箱，请检查后重试。",
  "input.attach": "附加照片或 PDF",
  "error.fileTooLarge": "文件过大。照片和 PDF 最大 10 MB。",
  "error.fileType": "您可以发送照片（JPG、PNG、GIF、WebP）或 PDF。",
  "error.fileFailed": "无法发送您的文件，请换一个文件试试。",
  "attachment.photo": "照片",
  "attachment.file": "文件",
  "attachment.sending": "正在发送...",
  "error.verificationFailed": "无法验证您的消息，请刷新页面后重试。",
  "challenge.label": "安全验证",
  "challenge.prompt": "发送消息前需要进行一次快速安全验证。",
  "csat.defaultQuestion": "您如何评价今天获得的支持？",
  "csat.thankYou": "感谢您的反馈！",
} as const;
